// brand-replace.js
(function () {
  const FIND_STR = "The Garrison";
  const REPLACE_STR = "Castleson";
  const CASE_INSENSITIVE = false;

  const POPUP_SELECTORS = [
    "shopify-modal","shopify-geolocation-modal",
    "#shopify-section-geolocation-popup",
    "[id*='geolocation']","[class*='geolocation']",
    "[data-section-type='geolocation']",
    "[data-shopify='localization-modal']","[data-shopify='localization-form']",
    "[role='dialog']","[aria-modal='true']",
    ".modal",".modal__content",".popup",".popup__content",
    ".drawer",".drawer__inner",".overlay",".overlay--active",
    "[data-brand-skip]"
  ].join(",");

  const STRUCTURE_SKIP = [
    "nav","header",".site-header",".header",".navigation",".nav",".menu",
    "#shopify-section-header",".shopify-section-header"
  ].join(",");

  const TAG_SKIP = new Set([
    "SCRIPT","STYLE","NOSCRIPT","TEXTAREA","INPUT","SELECT","OPTION","IFRAME","SVG","CODE","PRE"
  ]);

  const cmp = s => CASE_INSENSITIVE ? String(s).toLowerCase() : String(s);
  const NEEDLE = cmp(FIND_STR);

  function inSkipZone(el){ return !!(el && el.closest && (el.closest(POPUP_SELECTORS) || el.closest(STRUCTURE_SKIP))); }

  function replaceTitle(){
    if (!document.title) return;
    document.title = CASE_INSENSITIVE
      ? document.title.replace(new RegExp(FIND_STR, "gi"), REPLACE_STR)
      : document.title.replaceAll(FIND_STR, REPLACE_STR);
  }

  function walker(root){
    return document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node){
        const p = node.parentNode; if (!p) return NodeFilter.FILTER_REJECT;
        if (TAG_SKIP.has(p.nodeName)) return NodeFilter.FILTER_REJECT;
        if (inSkipZone(p)) return NodeFilter.FILTER_REJECT;
        const v = node.nodeValue; if (!v || !v.trim()) return NodeFilter.FILTER_SKIP;
        return CASE_INSENSITIVE ? (v.toLowerCase().includes(NEEDLE) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP)
                                : (v.includes(FIND_STR) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP);
      }
    });
  }

  function replaceAcross(root){
    if (!root || (root.nodeType === 1 && inSkipZone(root))) return;
    const w = walker(root), nodes = []; while (w.nextNode()) nodes.push(w.currentNode);
    if (!nodes.length) return;

    const idx = new Map(nodes.map((n,i)=>[n,i]));
    const norm = s => CASE_INSENSITIVE ? s.toLowerCase() : s;
    function* positions(){ for (const n of nodes){ const v=n.nodeValue; for (let i=0;i<v.length;i++) yield {node:n,offset:i}; } }
    const nextNode = n => nodes[idx.get(n)+1] || null;

    outer:
    for (const start of positions()){
      let n=start.node,o=start.offset; if (!idx.has(n)) continue;
      if (norm(n.nodeValue.charAt(o)) !== NEEDLE.charAt(0)) continue;
      let matched=1, curNode=n, curOff=o+1;
      while (matched < NEEDLE.length){
        if (!curNode) continue outer;
        if (curOff >= curNode.nodeValue.length){ curNode=nextNode(curNode); curOff=0; continue; }
        if (norm(curNode.nodeValue.charAt(curOff)) !== NEEDLE.charAt(matched)) continue outer;
        matched++; curOff++;
      }
      const range=document.createRange();
      range.setStart(n,o); range.setEnd(curNode,curOff);
      range.deleteContents();
      range.insertNode(document.createTextNode(REPLACE_STR));
      return replaceAcross(root); // opnieuw scannen na mutatie
    }
  }

  function getAllRoots(){
    const roots=[document];
    const stack=[...document.querySelectorAll("*")];
    for (let i=0;i<stack.length;i++){
      const el=stack[i];
      if (el && el.shadowRoot){
        roots.push(el.shadowRoot);
        stack.push(...el.shadowRoot.querySelectorAll("*"));
      }
    }
    return roots;
  }

  function runAll(){
    replaceTitle();
    for (const root of getAllRoots()) replaceAcross(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runAll, { once:true });
  } else {
    runAll();
  }

  const observers=[];
  function observeRoot(root){
    const mo=new MutationObserver((muts)=>{
      for (const m of muts){
        if (m.addedNodes && m.addedNodes.length){
          for (const an of m.addedNodes){
            if (an.nodeType === 1 && !inSkipZone(an)){
              replaceAcross(an);
              if (an.shadowRoot) observeRoot(an.shadowRoot);
            }
          }
        }
      }
    });
    mo.observe(root,{ childList:true, subtree:true }); observers.push(mo);
  }

  window.addEventListener("load", ()=>{ for (const r of getAllRoots()) observeRoot(r); }, { once:true });
})();